import { render, staticRenderFns } from "./EmployeeRegistryContacts.vue?vue&type=template&id=3b1e1cac&scoped=true&"
import script from "./EmployeeRegistryContacts.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistryContacts.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRegistryContacts.vue?vue&type=style&index=0&id=3b1e1cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e1cac",
  null
  
)

export default component.exports